/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bell_Activity_Prices_OneInputs */

const en_bell_activity_prices_one = /** @type {(inputs: Bell_Activity_Prices_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prices of 1 line changed`)
};

/**
* | output |
* | --- |
* | "prices of 1 line changed" |
*
* @param {Bell_Activity_Prices_OneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_activity_prices_one = /** @type {((inputs?: Bell_Activity_Prices_OneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Activity_Prices_OneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_activity_prices_one(inputs)
});